// extracted by mini-css-extract-plugin
export var copyableField = "_ni-4";
export var customerBadge = "_ni-0";
export var customerInfoTitle = "_ni-2";
export var details = "_ni-1";
export var dropdownContainer = "_ni-5";
export var dropdownImage = "_ni-6";
export var editAssigneeForm = "_ni-a";
export var editButton = "_ni-3";
export var email = "_ni-7";
export var hidden = "_ni-d";
export var input = "_ni-8";
export var saveButton = "_ni-b";
export var shopifyIcon = "_ni-c";
export var suggestionBadge = "_ni-e";
export var suggestionText = "_ni-f";
export var username = "_ni-9";